//Helper functions to reduce duplicate code

export function isRedundantNavigation(
  currentRoute: string | any,
  targetRoute: string
): boolean {
  return currentRoute === targetRoute
}
